"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _animations = require("@qc-modules/animations");

var _glyph = _interopRequireDefault(require("../glyph"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isActive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PlaceHolder = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "faux-checkbox__PlaceHolder",
  componentId: "sc-1k4f29n-0"
})(["overflow:hidden;"]);
var CheckContainer = (0, _styledComponents["default"])(function (_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, props);
}).withConfig({
  displayName: "faux-checkbox__CheckContainer",
  componentId: "sc-1k4f29n-1"
})(["vertical-align:top;", ";"], (0, _styles.transitionEase)("0.25s", ["background", "border"]));
var propTypes = {
  /** Checkbox width */
  checkBoxWidth: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string]),

  /** A boolean to represent whether the input field should be disabled */
  checked: _propTypes.bool,

  /** Boolean for the input field */
  indeterminate: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),

  /** Margin right value for checkbox icon */
  mr: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.number, _propTypes.string])
};
var defaultProps = {
  checkBoxWidth: 16,
  mr: 1
};

var Checkbox = function Checkbox(_ref2) {
  var checkBoxWidth = _ref2.checkBoxWidth,
      checked = _ref2.checked,
      mr = _ref2.mr,
      indeterminate = _ref2.indeterminate;
  var checkSize = (0, _ramda.map)(function (val) {
    return parseInt(val, 10) - 4;
  }, (0, _ramda.flatten)([checkBoxWidth]));
  return /*#__PURE__*/_react["default"].createElement(CheckContainer, {
    alignItems: "center",
    backgroundColor: checked || indeterminate ? "background-selected" : "background",
    border: "1px solid",
    borderColor: checked || indeterminate ? "background-selected" : "border",
    borderRadius: 3,
    display: "inline-flex",
    height: checkBoxWidth,
    justifyContent: "center",
    mr: mr,
    mt: ["-2px", 0],
    p: "1px"
  }, /*#__PURE__*/_react["default"].createElement(_animations.Fade, {
    alwaysShowInDom: true,
    enterDuration: 0.25,
    exitDuration: 0.2,
    show: checked || indeterminate
  }, checked ? /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    "data-test": "checkbox-checked",
    fill: "icon-light",
    height: checkSize,
    id: "check",
    width: checkSize
  }) : /*#__PURE__*/_react["default"].createElement(PlaceHolder, {
    alignItems: "center",
    "data-test": "checkbox-unchecked",
    display: "inline-flex",
    height: checkSize,
    justifyContent: "center",
    width: checkSize
  }, indeterminate && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    backgroundColor: "background",
    borderRadius: 2,
    display: "inline-block",
    height: "2px",
    width: "8px"
  }))));
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
Checkbox.displayName = "Modules.FauxCheckbox";
var _default = Checkbox;
exports["default"] = _default;